import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { BUYER_NAMES, IMAGES } from '../utils/constants';
export function PurchasePopup() {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    // Initial delay before first popup
    const initialDelay = setTimeout(() => {
      showRandomPopup();
      startRandomInterval();
    }, 10000); // 10 seconds
    return () => {
      clearTimeout(initialDelay);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
  const startRandomInterval = () => {
    // Random interval between 15 and 30 seconds
    const nextInterval = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
    timerRef.current = setTimeout(() => {
      showRandomPopup();
      startRandomInterval();
    }, nextInterval);
  };
  const showRandomPopup = () => {
    const randomBuyer = BUYER_NAMES[Math.floor(Math.random() * BUYER_NAMES.length)];
    toast.custom(t => <div className="bg-white p-4 rounded-xl shadow-xl border border-gray-100 flex items-center space-x-4 w-80 animate-in slide-in-from-bottom-5" data-id="element-201">
          <img src={IMAGES.tomo3} alt="Product" className="w-12 h-auto object-contain drop-shadow-md" data-id="element-202" />
          <div data-id="element-203">
            <p className="text-sm text-stone-900 font-bold" data-id="element-204">
              {randomBuyer.name} da {randomBuyer.city}
            </p>
            <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-205">
              Ha appena acquistato questo prodotto
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-206">Qualche istante fa</p>
          </div>
        </div>, {
      duration: 4000,
      position: 'bottom-left'
    });
  };
  return null; // This component only handles logic and triggers toasts
}